import http from "../../../NetworkServices/http";

let consoleBaseUrl = process.env.REACT_APP_CH_CONSOLE_API_BASE_URL;
consoleBaseUrl = consoleBaseUrl + "api/v1";

export class BulkUpdateNetworkService {
  static getBulkUpdateStatus(taskId: string) {
    // the id can come back off localStorage, so it is not trusted to be path-safe
    return http.get(
      `${consoleBaseUrl}/workspace/bulk-update-status/${encodeURIComponent(taskId)}`,
    );
  }
}
